var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5162 17.087C22.5162 14.4359 21.063 12.8453 19.3546 12.3741C19.3153 11.7653 18.8048 11.2744 18.1763 11.2744C17.5479 11.2744 17.0374 11.7653 16.998 12.3741C15.2896 12.865 13.8364 14.436 13.8364 17.087C13.8364 17.087 13.8364 19.5416 12.7761 21.1322C12.7761 21.1322 12.2459 22.1925 13.3063 22.3694H23.0267C24.087 22.1927 23.5569 21.1322 23.5569 21.1322C22.5162 19.5613 22.5162 17.087 22.5162 17.087Z",
    fill: "#C679F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1767 24.7258C19.1586 24.7258 19.944 23.9403 19.944 22.9585H16.4093C16.4093 23.9206 17.1947 24.7258 18.1766 24.7258H18.1767Z",
    fill: "#C679F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.666504,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#E7E7E7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bellIcon.a35b03437db6df7ca1848aa77bfbca42.svg";
export { ForwardRef as ReactComponent };